import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FiltrosComponent } from './filtros/filtros.component';
import { Validators, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { MonthpickerComponent } from './monthpicker/monthpicker.component';
import { MenuComponent } from './menu/menu.component';
import { NbMenuModule, NbCardModule } from '@nebular/theme';
import { MatIconModule, MatButtonModule, MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatInputModule } from '@angular/material';
@NgModule({
  declarations: [FiltrosComponent, MonthpickerComponent, MenuComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    NbMenuModule,
    NbCardModule,
    MatButtonModule,
   MatIconModule,
   MatDatepickerModule,
   MatDialogModule,
   MatFormFieldModule,
   MatInputModule
  ],
  exports: [FiltrosComponent, MenuComponent
  ]
})
export class ComponentsModule { }
